<template>
    <div class="supplementBox">
        <div class="supplement">
            <h4>补充证据（调解）</h4>
            <p style="border: 1px solid #3b63f6"></p>
        </div>
        <div class="contractNameBox">
            <div class="contractName">
                <p>合同名称:</p>
                <el-input v-model="contractName.doc_title" disabled placeholder="请输入合同名称"></el-input>
            </div>
            <div class="contractType">
                <p>合同类型:</p>
                <el-input v-model="contractName.product_name" disabled placeholder="请输入合同类型"></el-input>
            </div>
            <div class="contractType">
                <p>被申请人:</p>
                <el-input v-model="contractName.signers_txt" disabled placeholder="请输入被申请人"></el-input>
            </div>
        </div>
        <div>
            <div class="matter" v-for="(i,index) in product_list" :key="index">
                <div style="flex-shrink:0" class="titleBox">
                    {{i.name}}
                </div>
                <el-upload
                        class="inline"
                        :limit="10"
                        :on-preview="handlePreview"
                        :on-remove="(file, fileList) => {handleRemove(file, fileList, i.id)}"
                        :on-success="handleSuccess"
                        :on-exceed="handleExceed"
                        accept=".pdf,.jpg,.png,.zip,.rar"
                        :headers="headers"
                        :action="url"
                        name="file"
                        :data="upload_data"
                        :file-list="i.file_list"
                        :on-progress="onProgress"

                >
                    <el-button class="custom" @click="submitUpload(i.id)">
                        上传
                    </el-button>
                </el-upload>

            </div>
            <div class="save" style="margin: auto;">
                <el-button  class="save" @click="preserve">保存证据</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import { mediateSupplementList, mediateSupplementSave } from '../../../api/mediateCase';

    export default {
        name: 'mediateSupplement',
        data(){
            return{
                id:'',
                url:process.env.VUE_APP_BASE_API+'/api/upload_tiaojie_extra_evifile',
                headers:{
                    "Authorization": sessionStorage.getItem("token"),
                    "Comid": sessionStorage.getItem("shenfen"),
                    "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn
                },
                contractName:'',
                upload_data:{
                    case_id:'',
                    evidence_id:''
                },
                case_id:'',
                product_list:[],
                evidence_datas:[]
            }
        },
        methods:{
            //点击文件列表事件
            handlePreview(file){
                if (file.all_url){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.all_url;
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.all_url);
                }else if (file.response){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.response.data.all_url;
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.response.data.all_url);
                }
            },
            //上传成功
            handleSuccess(response, file, fileList){
                if (response.code==200){
                    this.product_list.forEach((item,index)=>{
                        const obj = {
                            name:response.data.file_name,
                            file_name:response.data.file_name,
                            file_url:response.data.file_url,
                            psd_code:response.data.psd_code,
                            all_url:response.data.all_url,
                        };
                        if (item.file_list && item.id == this.upload_data.evidence_id){
                            item.file_list.push(obj)
                            const psd_arr = [];
                            item.file_list.forEach((par,is)=>{
                                psd_arr.push(par.psd_code)
                            })
                            let is_cunzai = false;
                            if(this.evidence_datas.length > 0){
                                this.evidence_datas.forEach((param,i)=>{
                                    if(param.evidence_id == this.upload_data.evidence_id){
                                        is_cunzai = true;
                                        param.psd_codes = psd_arr;
                                    }
                                })
                            }
                            if(!is_cunzai){
                                this.evidence_datas.push({
                                    evidence_id:this.upload_data.evidence_id,
                                    psd_codes:psd_arr
                                })
                            }
                        }else if (!item.file_list && itm.id == this.upload_data.evidence_id){
                            item.file_list = [obj]
                            const psd_arr = [];
                            item.file_list.forEach((par,is)=>{
                                psd_arr.push(par.psd_code)
                            })
                            let is_cunzai = false;
                            if(this.evidence_datas.length > 0){
                                this.evidence_datas.forEach((param,i)=>{
                                    if(param.evidence_id == this.upload_data.evidence_id){
                                        is_cunzai = true;
                                        param.psd_codes = psd_arr;
                                    }
                                })
                            }
                            if(!is_cunzai){
                                this.evidence_datas.push({
                                    evidence_id:this.upload_data.evidence_id,
                                    psd_codes:psd_arr
                                })
                            }
                        }
                    })
                    // this.evidence_datas.push({
                    //     evidence_id:this.upload_data.evidence_id,
                    //     psd_codes:response.data.psd_code
                    // })
                }

            },
            //限制条数
            handleExceed(files, fileList){
                if (fileList.length>=10){
                    this.$message.error('只能上传10个文件');
                }
            },
            //移除事件
            handleRemove(file, fileList,i){
                this.product_list.forEach((item,index)=>{
                    if(item.id == i){
                        const psd_arr = [];
                        item.file_list.forEach((it,ix)=>{
                            if(it.psd_code == file.psd_code){
                                item.file_list.splice(ix,1)
                            }
                        })
                        if(item.file_list.length > 0){
                            item.file_list.forEach((par,is)=>{
                                psd_arr.push(par.psd_code)
                            })
                        }
                        let is_cunzai = false;
                        if(this.evidence_datas.length > 0){
                            this.evidence_datas.forEach((param,i)=>{
                                if(param.evidence_id == i){
                                    is_cunzai = true;
                                    param.psd_codes = psd_arr;
                                }
                            })
                        }
                        if(!is_cunzai){
                            this.evidence_datas.push({
                                evidence_id:i,
                                psd_codes:psd_arr
                            })
                        }
                    }
                })
            },
            submitUpload(i){
                this.upload_data.case_id=this.id
                this.upload_data.evidence_id=i
            },
            //保存
            preserve(){
                mediateSupplementSave(this.case_id,this.evidence_datas).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.$router.push('/mediate')
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //上传文件进度未上传完成时添加loading
            onProgress({ percent }) {
                if (percent!==100){
                    this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                }else {
                    this.$loading().close()
                }
            }
        },
        created() {
            this.headers.Comid=JSON.parse(sessionStorage.getItem("shenfen")).com_id
            this.id=this.$route.query.id
            mediateSupplementList(this.$route.query.id).then(res=>{
                if (res.code==200){
                    this.case_id=res.data.id
                    this.contractName=res.data
                    this.product_list=res.data.product_list
                }else {
                    this.$message.error(res.msg);
                }
            })
        }
    };
</script>

<style scoped>
    .supplementBox{
        padding: 30px;
        border-radius: 5px;
        background-color: #fff;
    }
    .supplementBox{
        padding: 30px;
        min-width: 95% !important;
        width: max-content;
        background-color: #fff;
    }
    .supplement>h4{
        width: 150px;
        color: #3e60f5;
        text-align: center;
        margin-bottom: 8px;
    }
    .supplement>p{
        width: 150px;
    }
    .supplement{
        margin-bottom: 20px;
    }
    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
    }
    /deep/.el-upload--text{
        width: 60px;
        height: 100%;
        border: 0px;
        /*background-color: #3b63f6;*/
        color: #fff;
    }
    /deep/.el-upload-list{
        /*width: 150px;*/
        display: flex;
        align-items: flex-end;
    }
    .matter{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    /*上传按钮*/
    .custom{
        background-color: #3b63f6;
        color: #fff;

    }
    /deep/.el-upload-list__item-name{
        width: 150px;
    }
    /deep/.el-input__inner{
        color: #878889 !important;
    }
    /deep/.el-upload-list--text{
        margin-right: 30px;
    }
    .save{
        width: 120px;
        background-color: #3b63f6;
        color: #fff;
        height: 40px;
        border-radius: 5px;
    }
    .titleBox{
        min-width: 10%;
        max-width: 10%;
        color: #666666;
        font-size: 14px;
    }
    .contractNameBox{
        display: flex;
        margin: 20px 0px;
        font-size: 14px;
    }
    .contractNameBox>div{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
    }
    .contractNameBox p{
        width: 120px;
        color: #666666;
    }
</style>
